import { Modal } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { EditModalContext } from '../ContactsEditModal/context';

import { FLOW_STEPS } from './constant';
import { ProductList } from './ProductList';
import { GiftReviewAndSubmit } from './ReviewAndSubmit';

export function EditableProductsModal({
  isModalOpen,
  selectedProducts: initialSelectedProducts,
  onRequestClose,
  ...props
}) {
  const [currentFlow, setCurrentFlow] = useState(FLOW_STEPS.productList);
  const [modalObject, setModalObject] = useState({});
  const [newEstimatedCharge, setNewEstimatedCharge] = useState({});
  const [selectedProducts, setSelectedProducts] = useState(initialSelectedProducts);

  useEffect(() => {
    setSelectedProducts(initialSelectedProducts);
  }, [initialSelectedProducts]);

  const flowSteps = {
    [FLOW_STEPS.productList]: ProductList,
    [FLOW_STEPS.reviewAndSubmit]: GiftReviewAndSubmit
  };

  const Content = flowSteps[currentFlow];

  return (
    <EditModalContext.Provider value={newEstimatedCharge}>
      <Modal {...modalObject} isOpen={isModalOpen} onRequestClose={onRequestClose} size="xl">
        <Content
          {...{
            setCurrentFlow,
            onRequestClose,
            setModalObject,
            setNewEstimatedCharge,
            selectedProducts,
            setSelectedProducts,
            initialSelectedProducts,
            ...props
          }}
        />
      </Modal>
    </EditModalContext.Provider>
  );
}

EditableProductsModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  selectedProducts: PropTypes.array.isRequired,
  onRequestClose: PropTypes.func.isRequired
};
